"use client";

import { useEffect, useState } from "react";

const DISMISSED_KEY = "cookie-banner-dismissed";

const CookieBanner = () => {
  const [dismissed, setDismissed] = useState(true);

  useEffect(() => {
    const alreadyDismissed = window.localStorage.getItem(DISMISSED_KEY);
    setDismissed(alreadyDismissed === "true");
  }, []);

  const handleDismiss = () => {
    window.localStorage.setItem(DISMISSED_KEY, "true");
    setDismissed(true);
  };

  if (dismissed) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 flex flex-col items-center justify-between gap-3 bg-slate-900 px-4 py-4 text-slate-50 sm:flex-row sm:px-6">
      <p className="text-sm">
        Deze website gebruikt cookies om je ervaring te verbeteren.
      </p>
      <div className="flex shrink-0 gap-2">
        <button
          type="button"
          onClick={handleDismiss}
          className="rounded-md border border-slate-500 px-3 py-1.5 text-sm font-medium hover:bg-slate-800"
        >
          Weigeren
        </button>
        <button
          type="button"
          onClick={handleDismiss}
          className="rounded-md bg-white px-3 py-1.5 text-sm font-medium text-slate-900 hover:bg-slate-100"
        >
          Accepteren
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
